import moment from 'moment/moment';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { usePagination } from '../pagination/usePagination';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';
import { ConfigServer } from '../../data/config';
import { cedimi, sharp } from '../../constant/globalConstantsTypeClients';


export const useInformedConsent = () => {

    const [createSweet] = useSweetAlert();
    const history = useHistory();

    const [searchNim, setSearchNim] = useState("");
    const [date_ini, setDate_ini] = useState("");
    const [date_end, setDate_end] = useState("");
    const [searchName, setSearchName] = useState("");

    const [filters, setFilters] = useState(true);
    const [loadingFilters, setLoadingFilters] = useState(false);
    const [listInformedConsent, setListInformedConsent] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    // ? PREVIEW
    const [loadingPreviewId, setLoadingPreviewId] = useState(null);
    const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
    const [showPreview, setShowPreview] = useState(false);
    const [loadingDownloadId, setLoadingDownloadId] = useState(null);

    const url_helen = localStorage.getItem("url_helen");

    useEffect(() => {
        getInformedConsent()
    }, [])


    const handleChangeValue = (e) => {
        const { name, value } = e.target;

        if (name === "date_ini") {
            setDate_ini(value);
        }
        else if (name === "date_end") {
            setDate_end(value);
        }
        else if (name === "searchNim") {
            setSearchNim(value);
        }
        else if (name === "searchName") {
            setSearchName(value);
        }
    }

    const handleFilter = () => {
        setSearchTerm("");

        getInformedConsent(
            searchNim.trim(),
            date_ini,
            date_end,
            searchName.trim()
        );
    };

    
    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleClearSearch = () => {
        setSearchTerm("");
    };
    
    const filteredInformedConsent = listInformedConsent.filter((item) => {
        const term = searchTerm.trim().toLowerCase();

        if (!term) {
            return true;
        }

        const nim = String(item.nim ?? "").toLowerCase();
        const name = String(item.name ?? "").toLowerCase();
        const surnames = String(item.surnames ?? "").toLowerCase();
        const date = String(item.date ?? "").toLowerCase();

        return (
            nim.includes(term) ||
            name.includes(term) ||
            surnames.includes(term) ||
            date.includes(term)
        );
    });

    const getInformedConsent = async (nim = "", date1 = "", date2 = "", search = "") => {
        setLoadingFilters(true);

        const requestOptions = {
            method: "GET"
        };

        const params = new URLSearchParams();

        if (nim?.trim()) {
            params.append("nim", nim.trim());
        }

        if (date1) {
            params.append("date_ini", date1);
        }

        if (date2) {
            params.append("date_end", date2);
        }

        if (search?.trim()) {
            params.append("search", search.trim());
        }

        const isSpecialClient = [cedimi, sharp].includes(url_helen);
        const endpoint = isSpecialClient
            ? "Sample/ListPatientCISample"
            : "Sample/ListPatientCISampleSurvey";

        const queryString = params.toString();
        const url = queryString ? `${endpoint}?${queryString}` : endpoint;

        try {
            const response = await sendRequest(requestOptions, url);

            if (response.code === 200) {
                setListInformedConsent(response.data || []);
            }

            else if (response.code === 401) {
                validarSesion(history, response.code, getInformedConsent);
            }
            else if (response.code === 500) {
                createSweet("error", "error", "Consentimiento informado", "Ocurrió un error en el servidor");
            }
            else {
                createSweet("error", "warning", "Consentimiento informado", response.data?.msg || "No se pudo consultar la información");
            }
        }
        catch (error) {
            console.error("Error loading informed consents:", error);
            createSweet("error", "error", "Consentimiento informado", "Ocurrió un error al consultar la información");
        }
        finally {
            setLoadingFilters(false);
        }
    };

    const handleOpenPreview = async (nim) => {

        setLoadingPreviewId(nim);

        try {
            const token = localStorage.getItem("token");

            const isSpecialClient = [cedimi, sharp].includes(url_helen);

            const endpoint = isSpecialClient
                ? `/api/Sample/DownloadCi/${nim}`
                : `/api/TemplateConfigurationSurvey/GetAnswersPdf/${nim}`;

            const response = await fetch(
                ConfigServer.serverUrl + endpoint,
                {
                    method: 'GET',
                    headers: {
                        "Authorization": "Bearer " + token,
                        "Content-Type": "application/json"
                    }
                });

            if (!response.ok) {
                createSweet("warning", "warning", "No se pudo generar el PDF");
                return;
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            setPdfPreviewUrl(url);
            setShowPreview(true);

        } catch (error) {
            console.error("Error al generar el PDF:", error);
            createSweet("error", "error", "Ocurrió un error al generar el PDF");

        } finally {
            setLoadingPreviewId(null);
        }
    };


    const printPdfConsentInformed = async (nim = 0) => {

        setLoadingDownloadId(nim);
        try {
            const token = localStorage.getItem("token");

            const isSpecialClient = [cedimi, sharp].includes(url_helen);

            const endpoint = isSpecialClient
                ? `/api/Sample/DownloadCi/${nim}`
                : `/api/TemplateConfigurationSurvey/GetAnswersPdf/${nim}`;

            const response = await fetch(
                ConfigServer.serverUrl + endpoint,
                {
                    method: 'GET',
                    headers: {
                        "Authorization": "Bearer " + token,
                        "Content-Type": "application/json"
                    }
                }
            );

            if (!response.ok) {
                createSweet("warning", "warning", "No se descargó el PDF");
                return;
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `consentimiento_informado_${nim}.pdf`);
            document.body.appendChild(link);
            link.style.display = 'none';
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al descargar el PDF:", error);
            createSweet("error", "error", "Ocurrió un error al descargar el PDF");

        } finally {
            setLoadingDownloadId(null);
        }
    }

    const handleClean = () => {
        setSearchNim("");
        setSearchName("");
        setDate_ini("");
        setDate_end("");
        setSearchTerm("");

        getInformedConsent();
    };

    return {
        filters,
        setFilters,
        loadingFilters,
        handleClean,

        searchNim,
        date_ini,
        date_end,
        searchName,

        handleChangeValue,
        handleFilter,

        listInformedConsent,
        filteredInformedConsent,

        searchTerm,
        handleSearch,
        handleClearSearch,

        printPdfConsentInformed,
        loadingPreviewId,
        pdfPreviewUrl,
        showPreview,
        handleOpenPreview,
        setShowPreview,
        loadingDownloadId
    };

}
